// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3e4a7642] .avatar-uploader .el-upload{border:1px dashed #d9d9d9!important;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-3e4a7642]:hover{border-color:#409eff}[data-v-3e4a7642] .iconfont{font-size:20px!important;color:#8c939d!important;line-height:100px;text-align:center}.avatar[data-v-3e4a7642],[data-v-3e4a7642] .iconfont{width:100px;height:100px;display:block}", ""]);
// Exports
module.exports = exports;
